import { FilterType } from "@domain/enums/FilterType";
import { FilterMapper } from "@app/routing/mappers/FilterMapper";
import { EducationalFormFilterValue } from "@studyportals/search-api-interface";
import {IExtendedWithPortalTypeFilterValue} from "@app/routing/mappers/IExtendedWithPortalTypeFilterValue";

export class EducationalFormFilterMapper extends FilterMapper {
	public filterType: FilterType = FilterType.EDUCATIONAL_FORM;
	public isMultiSelect = true;
	private static instance: EducationalFormFilterMapper;

	protected values: IExtendedWithPortalTypeFilterValue[] = [
		{ id: EducationalFormFilterValue.ACADEMIC_COURSE, name: 'Academic Course' },
		{ id: EducationalFormFilterValue.CONFERENCE_SEMINAR, name: 'Conference/Seminar' },
		{ id: EducationalFormFilterValue.SUMMER_SCHOOL, name: 'Summer School' },
		{ id: EducationalFormFilterValue.WINTER_SCHOOL, name: 'Winter School' },
		{ id: EducationalFormFilterValue.SEMESTER_STUDY_ABROAD, name: 'Semester/Study Abroad' },
		{ id: EducationalFormFilterValue.SKILL_PROFESSIONAL_COURSE, name: 'Skill/Professional Course' },
	];

	public static getInstance(): EducationalFormFilterMapper {
		if (!EducationalFormFilterMapper.instance) {
			EducationalFormFilterMapper.instance = new EducationalFormFilterMapper();
		}
		return EducationalFormFilterMapper.instance;
	}

	private constructor() {
		super();
	}
}
